export class EnumUtils {
    /**
     * Retrieves the enum values of the given enum class.
     */
    static values(enumClass) {
        // Object.values on an enum class will return the values as well as the keys,
        // so we need to filter out the keys (which are strings with at least one uppercase letter)
        const enumValues = Object.values(enumClass);
        return enumValues.filter(value => typeof value === 'number' || (typeof value === 'string' && value === value.toLowerCase()));
    }
    /**
     * Retrieves the enum keys of the given enum class.
     */
    static keys(enumClass) {
        return Object.keys(enumClass);
    }
}
//# sourceMappingURL=EnumUtils.js.map